import { createContext, useContext, useEffect, useMemo, useState } from 'react';

const dictionaries = {
  fr: {
    appTitle: 'MOUSAIDI',
    menu: {
      register: 'Vente',
      products: 'Gestion articles',
      stock: 'Stock',
      partners: 'Partenaires',
      suppliers: 'Fournisseurs',
      cash: 'Caisse globale',
      finance: 'Finance',
      expenses: 'Depenses',
      users: 'Employes',
      payroll: 'Mon salaire',
      dashboard: 'Tableau de bord',
      logout: 'Deconnexion',
    },
    theme: {
      dark: 'Mode clair',
      light: 'Mode sombre',
    },
    login: {
      title: 'Connexion',
      username: "Nom d'utilisateur",
      password: 'Mot de passe',
      remember: 'Se souvenir de moi',
      submit: 'Connexion',
      forgot: 'Mot de passe oublie ?',
      failed: 'Connexion echouee',
    },
    snackbar: {
      confirm: 'Confirmer',
      cancel: 'Annuler',
    },
    common: {
      search: 'Rechercher',
      remove: 'Supprimer',
      action: 'Action',
      quantity: 'Quantite',
      price: 'Prix',
      stock: 'Stock',
      reference: 'Reference',
      article: 'Article',
      category: 'Categorie',
      printLastReceipt: 'Imprimer le dernier ticket',
      clearCart: 'Vider le panier',
      processing: 'Traitement...',
      checkoutAll: 'Tout valider',
      emptyCart: 'Panier vide',
    },
    pos: {
      title: 'Caisse: articles et prix',
      subtitle: 'Ajoutez au panier puis validez la vente en une seule operation.',
      saleType: 'Type de vente',
      normal: 'Normale',
      partner: 'Partenaire',
      partnerLabel: 'Partenaire',
      partnerLaterPay: 'Paiement plus tard',
      partnerCreditHint: 'Ce partenaire paie plus tard (credit).',
      scanSearch: 'Scanner / Rechercher',
      scanPlaceholder: 'Nom, code-barres, reference',
      globalDiscount: 'Remise globale %',
      addToCart: 'Ajouter',
      cartTitle: 'Panier',
      lineTotal: 'Total ligne',
      subtotal: 'Sous-total',
      discount: 'Remise',
      total: 'Total',
      cartEmpty: 'Le panier est vide.',
      checkoutSuccess: 'Vente validee',
      checkoutFailed: 'Validation echouee',
      partnerRequired: 'Veuillez choisir un partenaire',
      popupBlocked: 'Popup bloque: autorisez les popups',
      receiptTitle: 'Ticket de caisse',
      receiptType: 'Type',
      receiptPartner: 'Partenaire',
      receiptPayment: 'Paiement',
      paymentNow: 'Paye maintenant',
      paymentLater: 'Credit (payer plus tard)',
      saleTypeNormal: 'Vente normale',
      saleTypePartner: 'Vente partenaire',
    },
    products: {
      title: 'Gestion simple des articles',
      subtitle: 'Creer des articles, gerer le stock et vendre facilement.',
      productsCount: 'Articles',
      totalStock: 'Stock total',
      manageTab: 'Gestion',
      cashTab: 'Mode caisse',
      newProduct: 'Nouvel article',
      name: 'Nom',
      reference: 'Reference',
      referenceOptional: 'Reference (optionnelle)',
      autoReferenceHint: 'Si vide, une reference sera generee automatiquement',
      category: 'Categorie',
      categoryHint: 'Selectionnez ou ecrivez une categorie',
      barcode: 'Code-barres',
      supplierOptional: 'Fournisseur (optionnel)',
      noSupplier: 'Aucun fournisseur',
      purchasePrice: "Prix d'achat",
      salePrice: 'Prix de vente',
      initialStock: 'Stock initial',
      create: 'Creer article',
      listTitle: 'Liste des articles',
      searchPlaceholder: 'Nom, reference, categorie, code-barres',
      addStock: '+ Stock',
      sell: 'Vendre',
      stockAdded: 'Stock augmente',
      stockFailed: 'Echec mise a jour stock',
      sellDone: 'Vente enregistree',
      sellFailed: 'Vente echouee',
      createDone: 'Article cree',
      createFailed: 'Creation article echouee',
      empty: 'Aucun article trouve.',
      nameRequired: 'Le nom est obligatoire',
      fetchFailed: 'Impossible de charger les articles',
    },
  },
  ar: {
    appTitle: 'موسايدي',
    menu: {
      register: 'المبيعات',
      products: 'إدارة المنتجات',
      stock: 'المخزون',
      partners: 'الشركاء',
      suppliers: 'الموردون',
      cash: 'الصندوق العام',
      finance: 'المالية',
      expenses: 'المصاريف',
      users: 'الموظفون',
      payroll: 'راتبي',
      dashboard: 'لوحة التحكم',
      logout: 'تسجيل الخروج',
    },
    theme: {
      dark: 'وضع فاتح',
      light: 'وضع داكن',
    },
    login: {
      title: 'تسجيل الدخول',
      username: 'اسم المستخدم',
      password: 'كلمة المرور',
      remember: 'تذكرني',
      submit: 'دخول',
      forgot: 'نسيت كلمة المرور؟',
      failed: 'فشل تسجيل الدخول',
    },
    snackbar: {
      confirm: 'تأكيد',
      cancel: 'إلغاء',
    },
    common: {
      search: 'بحث',
      remove: 'حذف',
      action: 'إجراء',
      quantity: 'الكمية',
      price: 'السعر',
      stock: 'المخزون',
      reference: 'المرجع',
      article: 'المنتج',
      category: 'الفئة',
      printLastReceipt: 'طباعة آخر إيصال',
      clearCart: 'تفريغ السلة',
      processing: 'جار المعالجة...',
      checkoutAll: 'إنهاء العملية',
      emptyCart: 'السلة فارغة',
    },
    pos: {
      title: 'الكاشير: المنتجات والأسعار',
      subtitle: 'أضف المنتجات إلى السلة ثم أنهِ البيع دفعة واحدة.',
      saleType: 'نوع البيع',
      normal: 'عادي',
      partner: 'شريك',
      partnerLabel: 'الشريك',
      partnerLaterPay: 'دفع لاحق',
      partnerCreditHint: 'هذا الشريك يدفع لاحقا (دين).',
      scanSearch: 'مسح / بحث',
      scanPlaceholder: 'الاسم، الباركود، المرجع',
      globalDiscount: 'خصم عام %',
      addToCart: 'إضافة',
      cartTitle: 'السلة',
      lineTotal: 'إجمالي السطر',
      subtotal: 'المجموع الفرعي',
      discount: 'الخصم',
      total: 'الإجمالي',
      cartEmpty: 'السلة فارغة.',
      checkoutSuccess: 'تمت العملية بنجاح',
      checkoutFailed: 'فشلت العملية',
      partnerRequired: 'يرجى اختيار شريك',
      popupBlocked: 'تم حظر النافذة المنبثقة، يرجى السماح بها',
      receiptTitle: 'إيصال',
      receiptType: 'النوع',
      receiptPartner: 'الشريك',
      receiptPayment: 'الدفع',
      paymentNow: 'مدفوع الآن',
      paymentLater: 'دين (يدفع لاحقا)',
      saleTypeNormal: 'بيع عادي',
      saleTypePartner: 'بيع شريك',
    },
    products: {
      title: 'إدارة بسيطة للمنتجات',
      subtitle: 'أنشئ منتجات، حدّث المخزون، وبِع بسهولة.',
      productsCount: 'المنتجات',
      totalStock: 'إجمالي المخزون',
      manageTab: 'الإدارة',
      cashTab: 'وضع الكاشير',
      newProduct: 'منتج جديد',
      name: 'الاسم',
      reference: 'المرجع',
      referenceOptional: 'المرجع (اختياري)',
      autoReferenceHint: 'إذا كان فارغا سيتم توليد مرجع تلقائيا',
      category: 'الفئة',
      categoryHint: 'اختر فئة أو اكتب فئة جديدة',
      barcode: 'باركود',
      supplierOptional: 'المورد (اختياري)',
      noSupplier: 'بدون مورد',
      purchasePrice: 'سعر الشراء',
      salePrice: 'سعر البيع',
      initialStock: 'المخزون الابتدائي',
      create: 'إنشاء منتج',
      listTitle: 'قائمة المنتجات',
      searchPlaceholder: 'الاسم، المرجع، الفئة، الباركود',
      addStock: '+ مخزون',
      sell: 'بيع',
      stockAdded: 'تمت زيادة المخزون',
      stockFailed: 'فشل تحديث المخزون',
      sellDone: 'تم تسجيل البيع',
      sellFailed: 'فشلت عملية البيع',
      createDone: 'تم إنشاء المنتج',
      createFailed: 'فشل إنشاء المنتج',
      empty: 'لا توجد منتجات.',
      nameRequired: 'الاسم مطلوب',
      fetchFailed: 'تعذر تحميل المنتجات',
    },
  },
};

const I18nContext = createContext({
  lang: 'fr',
  setLang: () => {},
  t: (key) => key,
  isRTL: false,
});

const resolve = (obj, key) => key.split('.').reduce((acc, part) => (acc ? acc[part] : undefined), obj);

export function I18nProvider({ children }) {
  const [lang, setLang] = useState(() => {
    const stored = localStorage.getItem('app-lang');
    return stored === 'ar' ? 'ar' : 'fr';
  });

  useEffect(() => {
    localStorage.setItem('app-lang', lang);
    document.documentElement.lang = lang;
    document.documentElement.dir = lang === 'ar' ? 'rtl' : 'ltr';
    document.body.dir = lang === 'ar' ? 'rtl' : 'ltr';
  }, [lang]);

  const value = useMemo(() => {
    const dict = dictionaries[lang] || dictionaries.fr;
    return {
      lang,
      setLang,
      isRTL: lang === 'ar',
      t: (key) => resolve(dict, key) ?? key,
    };
  }, [lang]);

  return <I18nContext.Provider value={value}>{children}</I18nContext.Provider>;
}

export function useI18n() {
  return useContext(I18nContext);
}
